// extracted by mini-css-extract-plugin
module.exports = {"center":"_404-module--center--2NrGo"};